import { PaymentPlanEntryStatus, PaymentPlanEntryTypes, } from '@debbie/common/dist/economy/payment-plans/index.js';
import moment from 'moment';
import React from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import THEME from '../../../theme.js';
import Money from '../../Money.js';
const PlanOverview = (props) => {
    const { paymentPlan, singleCase } = props;
    const lang = useSelector((s) => s.lang);
    return (React.createElement("div", null, paymentPlan.plan.length > 0 && (React.createElement(Subsection, null,
        React.createElement(SubsectionHeader, null, lang.paymentPlans.entries),
        React.createElement(Timeline, null, buildTimelineSegments(paymentPlan.plan).map((seg, i) => (React.createElement(TimelineRow, { key: i },
            React.createElement(TimelineDot, { $active: i === 0 }),
            React.createElement(TimelineDate, null, moment(seg.startDate).format(THEME.DATE_FORMAT_SHORT)),
            React.createElement(TimelineAmount, null,
                React.createElement(Money, { amount: seg.amount, currency: singleCase?.currency }),
                ' ',
                seg.count > 1 && React.createElement(SegmentCount, null,
                    "\u00D7 ",
                    seg.count),
                seg.type === 'UPFRONT' && (React.createElement(SegmentTag, null, lang.paymentPlans.upfrontPayment)),
                seg.type === 'REST' && (React.createElement(SegmentTag, null, lang.paymentPlans.rest)),
                seg.paid && (React.createElement(SegmentTag, { $paid: true }, lang.paymentPlanEntryStatuses[PaymentPlanEntryStatus.SETTLED].toLowerCase())))))))))));
};
export default PlanOverview;
const Timeline = styled.div `
  display: flex;
  flex-direction: column;
  position: relative;
  padding-left: 12px;

  &::before {
    content: '';
    position: absolute;
    left: 5px;
    top: 8px;
    bottom: 8px;
    width: 2px;
    background: ${THEME.BORDER};
  }
`;
const TimelineRow = styled.div `
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 6px 0;
  position: relative;
`;
const TimelineDot = styled.span `
  position: absolute;
  left: -12px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: ${({ $active }) => ($active ? THEME.COLOR_ACCENT : THEME.FILL)};
  border: 2px solid #fff;
  box-shadow: 0 0 0 1px
    ${({ $active }) => ($active ? THEME.COLOR_ACCENT : THEME.BORDER_STRONG)};
`;
const TimelineDate = styled.span `
  font-size: 12px;
  color: ${THEME.TEXT_MUTED};
  min-width: 70px;
  margin-left: 4px;
`;
const TimelineAmount = styled.span `
  font-size: 14px;
  font-weight: 600;
  color: #222;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
`;
const SegmentCount = styled.span `
  font-size: 13px;
  font-weight: 500;
  color: ${THEME.TEXT_MUTED};
`;
const SegmentTag = styled.span `
  background: ${({ $paid }) => ($paid ? '#e6f4ea' : THEME.SURFACE_MUTED)};
  color: ${({ $paid }) => ($paid ? '#1e7d3a' : THEME.TEXT_MUTED)};
  border-radius: 4px;
  padding: 2px 8px;
  font-size: 11px;
  font-weight: 500;
  text-transform: lowercase;
  letter-spacing: 0.02em;
`;
const Subsection = styled.div `
  background: #fff;
  border: 1px solid ${THEME.BORDER};
  border-radius: 6px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
const SubsectionHeader = styled.h5 `
  margin: 0 0 4px 0;
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: ${THEME.TEXT_MUTED};
`;
// Group plan entries into segments for the timeline. Consecutive NORMAL
// entries with the same amount and same paid-state are folded together so
// the timeline reads as `DKK 700 × 3 paid`, `DKK 700 × 7`, etc. UPFRONT
// and REST always get their own row.
const buildTimelineSegments = (plan) => {
    const segments = [];
    for (const entry of plan) {
        const amount = entry.amount ?? 0;
        const paid = entry.status === PaymentPlanEntryStatus.SETTLED;
        if (entry.type !== PaymentPlanEntryTypes.NORMAL) {
            segments.push({
                startDate: entry.date,
                amount,
                count: 1,
                paid,
                type: entry.type,
            });
            continue;
        }
        const last = segments[segments.length - 1];
        if (last &&
            last.type === PaymentPlanEntryTypes.NORMAL &&
            last.amount === amount &&
            last.paid === paid) {
            last.count += 1;
        }
        else {
            segments.push({
                startDate: entry.date,
                amount,
                count: 1,
                paid,
                type: PaymentPlanEntryTypes.NORMAL,
            });
        }
    }
    return segments;
};
//# sourceMappingURL=PlanOverview.js.map